// extracted by mini-css-extract-plugin
module.exports = {"customStyles":"styles__customStyles___3_sLD","Select-control":"styles__Select-control___3DVU5","Select-placeholder":"styles__Select-placeholder___19fc9"};